import {useRef, useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Modal as BSModal} from 'bootstrap';
import enumList from 'web/utils/enumList';

export const useAlertModal = () => {
  const dispatch = useDispatch();
  const [actionIds, setActionIds] = useState([]);
  const [actionType, setActionType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [actionMode, setActionMode] = useState(enumList.alertModalModeEnums.enable);
  const alertModalInstance = useRef(null);
  const alertRef = useRef(null);

  useEffect(() => {
    if (alertRef.current && !alertModalInstance.current) {
      alertModalInstance.current = new BSModal(alertRef.current);
    }
  }, []);

  const toggleAlertModal = (isShow, mode = enumList.alertModalModeEnums.enable, type, message = '', actionCodes = []) => {
    if (alertModalInstance) {
      if (isShow) {
        let alertMessage = message;
        if (alertMessage === '') {
          const length = actionCodes.length;
          if (mode === enumList.alertModalModeEnums.enable) {
            alertMessage = `啟用 [ ${length} ] 筆資料`;
          } else if (mode === enumList.alertModalModeEnums.disable) {
            alertMessage = `停用 [ ${length} ] 筆資料`;
          }
        }
        setActionType(type);
        setActionMode(mode);
        setAlertMessage(alertMessage);
        setActionIds(actionCodes);

        alertModalInstance.current.show();
      } else {
        alertModalInstance.current.hide();
      }
    }
  };

  return {
    alertRef,
    toggleAlertModal,
    actionIds,
    setActionIds,
    actionType,
    setActionType,
    alertMessage,
    setAlertMessage,
    actionMode,
    setActionMode,
    alertModalInstance,
  };
};

export default useAlertModal;
